(function () {
  var search = document.querySelector(".biosphere-header__search");
  if (!search) return;

  var close = search.querySelector("[data-close]");
  if (!close) return;

  close.addEventListener("click", function () {
    search.open = false;
    search.querySelector("summary")?.focus();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape" || !search.open) return;
    search.open = false;
    search.querySelector("summary")?.focus();
  });

  close.hidden = false;
})();
